import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Container, InputGroup, Table, Modal, Button, Form, Row, Col, Spinner, Nav, Tab, Image } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import * as Icon from "react-bootstrap-icons";
import { useLocation, useNavigate } from 'react-router-dom';
import normal from "../../images/gif/frame-88.png"
import medium from "../../images/gif/Ripple-6.3s-200px.gif";
import immediate from "../../images/gif/Ripple-1s-200px (1).gif"
import Badge from 'react-bootstrap/Badge';
import { getAllAllocatedTask, setActiveToggle, setFilterTasksData } from './AllTaskSlice';
import Pagination from './Pagination'
import FilterTaskModel from './Model/FilterTaskModel';
import { AcceptModel } from './Model/AcceptModel';
import { RejectModel } from './Model/RejectModel';
import { AssignAllocatedTaskModel } from './Model/AssignAllocatedTaskModel';
import { FilterSelfTaskModel } from './Model/FilterSelfTaskModel';
import { FilterAllocatedTaskModel } from './Model/Filter AllocatedTaskModel';
import DisplayHoursAndMinutes from './Convertor/DisplayHoursAndMinutes';
import useGetSubDepartments from './ReuseApi/useGetSubDepartments';
import { useProjectList } from './ReuseApi/useProjectList ';
import useGetDepartments from './ReuseApi/useGetDepartments';
import AssignedTaskFilter from './Filter/AssignedTaskFilter';
import { toast } from 'react-toastify';
import CompleteTaskModal from './Model/CompleteTaskModal';

const AllocatedTask = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const currentToggle = useSelector((state) => state?.AllTasks?.ActiveToggle);
    const loginUserData = useSelector((state) => state.loginData.userData)
    const deptNameArray = (loginUserData?.department).map((itm) => itm.label)
    const allAllocatedTasks = useSelector(state => state?.AllTasks?.AllocatedTask)
    const filterAllTasks = useSelector((state) => state?.AllTasks?.AllFilterTasksData);
    const { empId, firstName, lastName } = useSelector(state => state?.loginData?.userData);
    const activeTabName = useSelector((state) => state.activeData?.activeNumberKey?.activeTab);

    const isOtherDeptTab = activeTabName === "Task Assigned From Other Dept";


    // filter department
    const departmentFilterOptions = [
        ...new Map(
            (allAllocatedTasks?.data || []).map(item => [
                item.departmentName,
                { label: item.departmentName, value: item.departmentName }
            ])
        ).values()
    ];

    // filter assignby
    const assignByOptions = [
        ...new Map(
            (allAllocatedTasks?.data || []).map(item => [
                item.assignBy_Name,
                { label: item.assignBy_Name, value: item.assignBy_Name }
            ])
        ).values()
    ];

    const [show, setShow] = useState(false)
    const [showfilter, setShowFilter] = useState(false)
    const [docsPerPage, setDocsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [item, setItem] = useState();

    const [project, setProject] = useState(null);
    const [department, setDepartment] = useState(null);
    const [subDepartment, setSubDepartment] = useState(null);
    const [assignby, setAssignBY] = useState(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [taskpriority, setTaskpriority] = useState("")
    const [idcMin, setIdcMin] = useState(null);
    const [idcMax, setIdcMax] = useState(null);
    const [qwdMin, setQwdMin] = useState(null);
    const [qwdMax, setQwdMax] = useState(null);

    const { allDepartmentOptionsById } = useGetDepartments();
    const { subDeptOptions } = useGetSubDepartments(department?.value);
    const { projectOptions, departmentOptions } = useProjectList(project?.value);


    // for filter tab value reset
    const [pendingFilterValues, setPendingFilterValues] = useState({});
    const [completedFilterValues, setCompletedFilterValues] = useState({});
    const [rejectedFilterValues, setRejectedFilterValues] = useState({})

    const [taskId, setTaskId] = useState("")
    const [showAssignModel, setShowAssignModel] = useState(false)
    const [showAcceptModel, setShowAcceptModel] = useState(false)
    const [showRejectModel, setShowRejectModel] = useState(false)

    // for show data not found
    const [showNoDataFound, setShowNoDataFound] = useState(false);
    const [activeTaskId, setActiveTaskId] = useState(null);
    const [taskStatusMap, setTaskStatusMap] = useState({});
    const [timeMap, setTimeMap] = useState({});
    const [showCompleteModal, setShowCompleteModal] = useState(false);
    const [selectedTaskId, setSelectedTaskId] = useState("");

    // for Allocated modal
    const getAllAllocatedTaskData = (page = currentPage) => {
        const payload = {
            empId: loginUserData?.empId,
            taskPriority: taskpriority?.value || "",
            taskName: "",
            department: "",
            subDepartmentName: subDepartment?.label,
            projectName: project?.label,
            resource_id: "",
            proposedStartDate: startDate,
            proposedEndDate: endDate,
            status: currentToggle === "pending" ? ["pending", "inProgress"] : currentToggle,
            idcMin: idcMin?.value || "",
            idcMax: idcMax?.value || "",
            qwdMin: qwdMin?.value || "",
            qwdMax: qwdMax?.value || "",
            slippage: "",
            efficiency: "",
            assignBy_Name: assignby?.label || "",
            documentsPerPage: docsPerPage,
            page: page
        }
        dispatch(getAllAllocatedTask(payload))
    }

    useEffect(() => {
        getAllAllocatedTaskData()
    }, [currentPage, docsPerPage, currentToggle])


    const deriveStatusFromLog = (task) => {
        const logs = task.taskActionLog || [];

        if (task.status === "completed") return "completed";
        if (task.status === "rejected") return "rejected";

        if (!logs.length) return null;

        const lastAction = logs[logs.length - 1].actionStatus;

        switch (lastAction) {
            case "start":
            case "resume":
                return "running";

            case "pause":
                return "paused";

            case "end":
                return "completed";

            default:
                return null;
        }
    };
    useEffect(() => {
        localStorage.setItem("taskStatusMap", JSON.stringify(taskStatusMap));
    }, [taskStatusMap]);

    useEffect(() => {
        if (allAllocatedTasks?.data?.length) {
            const newStatusMap = {};
            let runningTask = null;

            allAllocatedTasks.data.forEach(task => {
                const status = deriveStatusFromLog(task);
                newStatusMap[task.taskId] = status;

                if (status === "running") {
                    runningTask = task.taskId;
                }
            });

            setTaskStatusMap(newStatusMap);
            setActiveTaskId(runningTask);
        }
    }, [allAllocatedTasks]);

    const actions = {
        START: "start",
        PAUSE: "pause",
        RESUME: "resume",
        END: "end"
    };

    useEffect(() => {
        let interval;

        if (activeTaskId) {
            interval = setInterval(() => {
                setTimeMap((prev) => ({
                    ...prev,
                    [activeTaskId]: (prev[activeTaskId] || 0) + 1,
                }));
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [activeTaskId]);


    const handleStart = async (taskId) => {
        try {
            if (activeTaskId && activeTaskId !== taskId) {
                await axios.post(
                    process.env.REACT_APP_BASE_URL + "/task/taskAction",
                    {
                        taskId: activeTaskId,
                        action: "pause",
                        resource_id: empId,
                        resourceName: `${firstName} ${lastName}`,
                        reason: ""
                    }
                );
            }

            await axios.post(
                process.env.REACT_APP_BASE_URL + "/task/taskAction",
                {
                    taskId: taskId,
                    action: "start",
                    resource_id: empId,
                    resourceName: `${firstName} ${lastName}`,
                    reason: ""
                }
            );

            getAllAllocatedTaskData();

        } catch (error) {
            toast.error("Error while switching tasks");
        }
    };

    const handlePause = (taskId) => {
        setActiveTaskId(null);
        setTaskStatusMap(prev => ({ ...prev, [taskId]: "paused" }));
    };

    const handleResume = async (taskId) => {
        try {
            if (activeTaskId && activeTaskId !== taskId) {
                await axios.post(
                    process.env.REACT_APP_BASE_URL + "/task/taskAction",
                    {
                        taskId: activeTaskId,
                        action: "pause",
                        resource_id: empId,
                        resourceName: `${firstName} ${lastName}`,
                        reason: ""
                    }
                );
            }

            await axios.post(
                process.env.REACT_APP_BASE_URL + "/task/taskAction",
                {
                    taskId: taskId,
                    action: "start",
                    resource_id: empId,
                    resourceName: `${firstName} ${lastName}`,
                    reason: ""
                }
            );

            getAllAllocatedTaskData();

        } catch (error) {
            toast.error("Error while resuming task");
        }
    };

    const handleStop = (taskId) => {
        setActiveTaskId(null);
        setTaskStatusMap(prev => ({ ...prev, [taskId]: "completed" }));
    };

    const handleToggleChange = (toggleValue) => {
        dispatch(setActiveToggle(toggleValue));
        if (toggleValue === 'pending') {
            setCompletedFilterValues({});
        } else {
            setPendingFilterValues({});
        }
    };

    const handleToggleTimer = async (taskId, curAction, extraData = {}) => {
        const actionsVal = Object.values(actions);
        const action = curAction.toLowerCase();
        const actionInd = actionsVal.indexOf(action);


        try {
            const payload = {
                taskId,
                action: actionsVal[actionInd],
                resource_id: empId,
                resourceName: `${firstName} ${lastName}`,
                reason: '',
                completeRemark: extraData?.remark || "",
                actualHours: Number(extraData?.actualHours || 0),
                actualMinutes: Number(extraData?.actualMinutes || 0),
            }
            const endpoint = '/task/taskAction'
            const res = await axios.post(process.env.REACT_APP_BASE_URL + endpoint, payload);

            if (actionInd === 0) {
                await handleStart(taskId);
                return;
            } else if (actionInd === 1) {
                handlePause(taskId);
                getAllAllocatedTaskData();
            } else if (actionInd === 2) {
                handleResume(taskId);
                getAllAllocatedTaskData();
            } else if (actionInd === 3) {
                handleStop(taskId);
                getAllAllocatedTaskData();
            }

            if (res.status === 200) {
                toast.success(`Task ${actionInd === 0 ? "started" : actionInd === 1 ? "paused" : actionInd === 2 ? "resumed" : "ended"} successfully`);
                if (action === "end") {
                    getAllAllocatedTaskData();
                }
            } else if (res.status === 400) {
                toast.info('Task Is Already Running', {
                    toastId: "already-running"
                })
            } else {
                toast.error(`Failed to ${action} task`, {
                    toastId: "action-failed"
                });
            }

        } catch (error) {
            toast.error(`Error: ${error.response?.data?.message || error.message}`, {
                toastId: "action-error"
            });
        }
    }

    const handleOpenCompleteModal = (taskId) => {
        setSelectedTaskId(taskId);
        setShowCompleteModal(true);
    };

    const handleCloseCompleteModal = () => {
        setSelectedTaskId("");
        setShowCompleteModal(false);
    };

    const handleConfirmComplete = async (payload) => {
        await handleToggleTimer(
            selectedTaskId,
            actions.END,
            payload
        );

        handleCloseCompleteModal();
    };

    // for no data found true false
    const handleFilterTrue = () => {
        setShowNoDataFound(true)
    }

    const handleFilterFalse = () => {
        setShowNoDataFound(false)
    }




    const handlerCloseFilterModel = () => setShowFilter(false)

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);

    };

    const handleDocsPerPage = (docsPageProp) => {
        setCurrentPage(1);
        setDocsPerPage(docsPageProp);

    }

    // for accept model
    const handleAcceptModel = (id) => {
        setTaskId(id);
        setShowAcceptModel(true)
    }

    // for delete model
    const handleRejectModel = (id) => {
        setShowRejectModel(true)
        setTaskId(id);
    }

    const handleAssignModelOpen = (id) => {
        setTaskId(id);
        setShowAssignModel(true)
    }

    const handleAssignModelClose = (id) => {
        setTaskId(id);
        setShowAssignModel(false)
    }

    const handleCloseAcptModel = () => { getAllAllocatedTaskData(); setShowAcceptModel(false) }
    const handleCloseRjctModel = () => { getAllAllocatedTaskData(); setShowRejectModel(false) }

    const handleSearch = () => {
        setCurrentPage(1)
        getAllAllocatedTaskData(1)
    }

    const handleClear = () => {
        setProject(null);
        setDepartment(null);
        setSubDepartment(null);
        setAssignBY(null);
        setStartDate("");
        setEndDate("");
        setTaskpriority(null);
        setIdcMin(null);
        setIdcMax(null);
        setQwdMin(null);
        setQwdMax(null);
        setCurrentPage(1);
        dispatch(getAllAllocatedTask({
            empId: loginUserData?.empId,
            taskPriority: "",
            taskName: "",
            department: "",
            subDepartmentName: "",
            projectName: "",
            resource_id: "",
            proposedStartDate: "",
            proposedEndDate: "",
            status: currentToggle,
            idcMin: "",
            idcMax: "",
            qwdMin: "",
            qwdMax: "",
            slippage: "",
            efficiency: "",
            assignBy_Name: "",
            documentsPerPage: docsPerPage,
            page: currentPage
        }));
    };

    return (
        <div className='TLAssignedTask outletPadding' data-aos='fade-up'>
            <Container>
                <AssignedTaskFilter
                    projectOptions={projectOptions}
                    departmentOptions={departmentFilterOptions}
                    subDeptOptions={subDeptOptions}
                    assignByOptions={assignByOptions}
                    idcOptions={[
                        { label: "1", value: "1" },
                        { label: "2", value: "2" },
                        { label: "3", value: "3" },
                        { label: "4", value: "4" },
                        { label: "5", value: "5" },
                        { label: "6", value: "6" },
                        { label: "7", value: "7" },
                        { label: "8", value: "8" },
                        { label: "9", value: "9" },
                        { label: "10", value: "10" },
                    ]}
                    project={project}
                    setProject={setProject}
                    department={department}
                    taskpriority={taskpriority}
                    setTaskpriority={setTaskpriority}
                    setDepartment={setDepartment}
                    subDepartment={subDepartment}
                    setSubDepartment={setSubDepartment}
                    assignby={assignby}
                    setAssignBY={setAssignBY}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    etIdcMin={setIdcMin}
                    idcMax={idcMax}
                    setIdcMax={setIdcMax}
                    qwdMin={qwdMin}
                    setQwdMin={setQwdMin}
                    qwdMax={qwdMax}
                    setQwdMax={setQwdMax}
                    taskStatus={currentToggle}
                    onSubmit={handleSearch}
                    onClear={handleClear}
                />
                <AssignAllocatedTaskModel show={showAssignModel} close={handleAssignModelClose} data={taskId} />
                <CompleteTaskModal
                    show={showCompleteModal}
                    close={handleCloseCompleteModal}
                    onSubmit={handleConfirmComplete}
                />
                <AcceptModel show={showAcceptModel} close={handleCloseAcptModel} taskId={taskId} />
                <RejectModel show={showRejectModel} close={handleCloseRjctModel} taskId={taskId} />

                <Row className='d-flex justify-content-between align-items-center'>
                    {/* <Col md={6} className="d-flex justify-content-start align-items-center">
                        <Button
                            className={` ${filterAllTasks?.data?.length > 0 || showNoDataFound ? 'activeBtn' : 'primaryBtn'}`}
                            onClick={() => setShowFilter(true)}
                        >
                            <Icon.Funnel className='me-2' size={17} />
                            Filter
                        </Button>
                    </Col> */}
                    <Col sm={12} md={12} className='d-flex justify-content-end align-items-center'>
                        <ButtonGroup aria-label="Basic example">
                            <Button
                                disabled={currentToggle === "pending" ? true : false}
                                variant={currentToggle === 'pending' ? 'warning' : 'outline-warning'} // Use 'warning' when active, 'light' otherwise
                                onClick={() => {
                                    handleToggleChange('pending'); dispatch(setFilterTasksData([])); setShowNoDataFound(false)
                                }}
                            >
                                Pending
                            </Button>
                            <Button
                                disabled={currentToggle === "completed" ? true : false}
                                variant={currentToggle === 'completed' ? 'success' : 'outline-success'}
                                onClick={() => { handleToggleChange('completed'); dispatch(setFilterTasksData([])); setShowNoDataFound(false) }}
                            >
                                Completed
                            </Button>
                            <Button
                                disabled={currentToggle === "rejected" ? true : false}
                                variant={currentToggle === 'rejected' ? 'danger' : 'outline-danger'}
                                onClick={() => { handleToggleChange('rejected'); dispatch(setFilterTasksData([])); setShowNoDataFound(false) }}
                            >
                                Rejected
                            </Button>
                        </ButtonGroup>
                    </Col>
                </Row>
                {/* <Row className="mt-3">
                    <Col md={12} className="d-flex justify-content-end">
                        <Button className="activeBtn" onClick={handleExportExcel}>
                            <Icon.Download className="me-2" />
                            Export Excel
                        </Button>
                    </Col>
                </Row> */}
                <div className='outer-wrapper mx-auto'>
                    <div className='table-wrapper'>
                        <table>
                            <thead>
                                <tr className='tbl-header'>
                                    <th>Priority</th>
                                    {currentToggle === "pending" &&
                                        <th>Due(Days)</th>}
                                    <th>Project</th>
                                    <th className='taskwidth'>Task Name</th>
                                    <th>Department</th>
                                    <th>SubDepartment</th>
                                    {/* <th className="max-width-th">Category</th> */}
                                    <th className='assignwidth'>Assign By</th>
                                    <th>Date</th>
                                    <th>Initial Hr</th>
                                    {
                                        currentToggle === "completed" &&
                                        <>
                                            <th>Actual Hr</th>
                                            <th>IDC</th>
                                            <th>QWD</th>
                                            <th>Slippage</th>
                                            <th>Efficiency</th>

                                        </>
                                    }
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {filterAllTasks?.data?.length > 0 || !showNoDataFound ? (
                                <tbody>
                                    {
                                        allAllocatedTasks?.data !== null &&
                                            allAllocatedTasks?.data !== undefined &&
                                            allAllocatedTasks?.data?.length > 0 ? (
                                            (filterAllTasks?.data?.length > 0
                                                ? filterAllTasks?.data
                                                : allAllocatedTasks?.data
                                            ).map((itm) => {
                                                const { taskName, taskPriority, departmentName, subDepartmentName, categoryOfName, assignBy_Name, resourceName, proposedStartDate, proposedEndDate, status, idc, qwd,
                                                    slippage, efficiency, taskId, isAccepted, isRejected, initialEstimateHr, actualHours,
                                                    isTaskAssigned, isheadTask, isSelfTaskAssigned, isAssignedTask, isOtherDeptTaskAssigned, isReassignedTask, otherProjectName,
                                                    projectName } = itm;
                                                const isReassigned = itm?.reassignedStatus === "reassignedToOther";

                                                // for convert hours and minute
                                                const parts = initialEstimateHr.toFixed(2).toString().split(".");
                                                const integerPart = parseInt(parts[0]);
                                                const decimalPart = parseInt(parts[1]);
                                                const hours = integerPart;
                                                const minutes = Math.round((decimalPart / 100) * 60);


                                                // for due days
                                                const currentDate = new Date();
                                                const endDate = new Date(itm.proposedEndDate);
                                                const endTimestamp = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
                                                const currentTimestamp = Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

                                                let daysDifference = 0;
                                                if (currentTimestamp > endTimestamp) {
                                                    const differenceMillis = Math.abs(currentTimestamp - endTimestamp);
                                                    daysDifference = Math.ceil(differenceMillis / (1000 * 60 * 60 * 24));
                                                }
                                                const currentStatus =
                                                    taskStatusMap[itm.taskId] ??
                                                    status ??
                                                    "pending";

                                                const isAssignedIcon = isReassigned;
                                                const isTaskRunning =
                                                    currentStatus === "running" ||
                                                    currentStatus === "paused" ||
                                                    currentStatus === "completed";
                                                const isForceShow = isAssignedTask && isReassignedTask;

                                                const canShowPlay =
                                                    isOtherDeptTaskAssigned &&
                                                    !isAssignedIcon && !isheadTask

                                                const canShowAssign =
                                                    !isAssignedIcon &&
                                                    !isTaskRunning &&
                                                    !isheadTask
                                                return (
                                                    <tr key={Math.random() * 999999999}>
                                                        <td>
                                                            {taskPriority === "low" ?
                                                                <img width={50} height={50} src={normal} data-toggle="tooltip" title="Low" />
                                                                :
                                                                taskPriority === "medium"
                                                                    ?
                                                                    <img width={50} height={50} src={medium} data-toggle="tooltip" title="Medium" />
                                                                    :
                                                                    (taskPriority === "urgent" || taskPriority === "high")
                                                                        ?
                                                                        <img width={50} height={50} src={immediate} data-toggle="tooltip" title="Urgent" />
                                                                        : ''
                                                            }
                                                        </td>
                                                        {currentToggle === "pending" &&
                                                            <td>
                                                                <div className={`circle ${daysDifference < 5 ? 'green' : daysDifference < 15 ? 'orange' : 'red'}`} style={{ height: '35px', width: '35px', borderRadius: '55%', margin: 'auto' }}>
                                                                    <span className="number">{Math.floor(daysDifference)}</span>
                                                                </div>
                                                            </td>
                                                        }
                                                        <td>
                                                            {projectName === "Other"
                                                                ? otherProjectName
                                                                : projectName}
                                                        </td>
                                                        <td>{taskName}</td>
                                                        <td>{departmentName}</td>
                                                        <td>{subDepartmentName}</td>
                                                        {/* <td>{categoryOfName ? categoryOfName : "-"}</td> */}
                                                        <td>{assignBy_Name}</td>
                                                        <td>
                                                            {new Date(
                                                                proposedStartDate
                                                            ).toLocaleDateString("en-US", {
                                                                month: "long",
                                                                year: "numeric",
                                                            }) ==
                                                                new Date(proposedEndDate).toLocaleDateString("en-US", { month: "long", year: "numeric" })
                                                                ? `${new Date(
                                                                    proposedStartDate
                                                                ).getDate()} - ${new Date(
                                                                    proposedEndDate
                                                                ).getDate()} ${new Date(
                                                                    proposedStartDate
                                                                ).toLocaleDateString("en-US", {
                                                                    month: "long",
                                                                    year: "numeric",
                                                                })}`
                                                                : `${new Date(
                                                                    proposedStartDate
                                                                ).getDate()} ${new Date(
                                                                    proposedStartDate
                                                                ).toLocaleDateString("en-US", {
                                                                    month: "long",
                                                                    year: "numeric",
                                                                })} -  ${new Date(
                                                                    proposedEndDate
                                                                ).getDate()} ${new Date(
                                                                    proposedEndDate
                                                                ).toLocaleDateString("en-US", {
                                                                    month: "long",
                                                                    year: "numeric",
                                                                })}`}
                                                        </td>
                                                        {/* <td>{initialEstimateHr ? initialEstimateHr.toFixed(2)  : 0}</td> */}
                                                        <td><DisplayHoursAndMinutes value={initialEstimateHr} /></td>

                                                        {
                                                            currentToggle === "completed" &&
                                                            <>
                                                                <td><DisplayHoursAndMinutes value={actualHours} />{' '}</td>
                                                                <td>{idc !== null && idc !== undefined ? idc.toFixed(2) : 0}</td>
                                                                <td>{qwd !== null && qwd !== undefined ? qwd.toFixed(2) : 0}</td>
                                                                <td>{slippage !== null && slippage !== undefined ? slippage.toFixed(2) : 0}</td>
                                                                <td>{efficiency !== null && efficiency !== undefined ? efficiency.toFixed(2) : 0}</td>
                                                            </>
                                                        }

                                                        <td className='text-capitalize'>
                                                            <Badge bg={status === "completed" ? "success p-1 text-white" : "warning text-dark p-1"}>{currentStatus === "running" ? "In Progress" : currentStatus}</Badge>
                                                        </td>
                                                        <td>
                                                            <span data-toggle="tooltip" title="view">
                                                                <Icon.Eye size={22} className='me-2' onClick={() => {
                                                                    navigate(`/${loginUserData?.resourceType}/assign-task/view-details`, {
                                                                        state: { data: itm, isOtherDeptTask: isOtherDeptTab }
                                                                    })
                                                                }}
                                                                />

                                                                {/* {isOtherDeptTaskAssigned && (
                                                                    <>
                                                                        {currentStatus === "completed" ? (
                                                                            <Icon.CheckCircleFill size={20} color="green" title="Completed" />
                                                                        ) : currentStatus === "running" ? (
                                                                            <>
                                                                                <Icon.PauseFill
                                                                                    size={20}
                                                                                    color="orange"
                                                                                    className="cursor-pointer"
                                                                                    title="Pause"
                                                                                    onClick={() => handleToggleTimer(itm.taskId, actions.PAUSE)}
                                                                                />
                                                                                <Icon.StopFill
                                                                                    size={20}
                                                                                    color="red"
                                                                                    className="cursor-pointer"
                                                                                    title="Complete"
                                                                                    onClick={() => handleToggleTimer(itm.taskId, actions.END)}
                                                                                />
                                                                            </>
                                                                        ) : currentStatus === "paused" ? (
                                                                            <>
                                                                                <Icon.PlayFill
                                                                                    size={20}
                                                                                    color="blue"
                                                                                    className="cursor-pointer"
                                                                                    title="Resume"
                                                                                    onClick={() => handleToggleTimer(itm.taskId, actions.RESUME)}
                                                                                />
                                                                                <Icon.StopFill
                                                                                    size={20}
                                                                                    color="red"
                                                                                    className="cursor-pointer"
                                                                                    title="Stop"
                                                                                    onClick={() => handleToggleTimer(itm.taskId, actions.END)}
                                                                                />
                                                                            </>
                                                                        ) : (
                                                                            <Icon.PlayFill
                                                                                size={20}
                                                                                color="green"
                                                                                className="cursor-pointer"
                                                                                title="Start"
                                                                                onClick={() => handleToggleTimer(itm.taskId, actions.START)}
                                                                            />
                                                                        )}
                                                                    </>
                                                                )} */}
                                                                {/* PLAY BUTTON */}
                                                                {canShowPlay && (
                                                                    <>
                                                                        {currentStatus === "completed" ? (
                                                                            <Icon.CheckCircleFill size={20} color="green" title="Completed" />
                                                                        ) : currentStatus === "running" ? (
                                                                            <>
                                                                                <Icon.PauseFill
                                                                                    size={20}
                                                                                    color="orange"
                                                                                    title="Pause"
                                                                                    onClick={() => handleToggleTimer(itm.taskId, actions.PAUSE)}
                                                                                />
                                                                                <Icon.StopFill
                                                                                    size={20}
                                                                                    color="red"
                                                                                    title="Complete"
                                                                                    onClick={() => handleOpenCompleteModal(itm.taskId)}
                                                                                // onClick={() => handleToggleTimer(itm.taskId, actions.END)}
                                                                                />
                                                                            </>
                                                                        ) : currentStatus === "paused" ? (
                                                                            <>
                                                                                <Icon.PlayFill
                                                                                    size={20}
                                                                                    color="blue"
                                                                                    title="Resume"
                                                                                    onClick={() => handleToggleTimer(itm.taskId, actions.RESUME)}
                                                                                />
                                                                                <Icon.StopFill
                                                                                    size={20}
                                                                                    color="red"
                                                                                    title="Stop"
                                                                                    // onClick={() => handleToggleTimer(itm.taskId, actions.END)}
                                                                                    onClick={() => handleOpenCompleteModal(itm.taskId)}
                                                                                />
                                                                            </>
                                                                        ) : (
                                                                            <Icon.PlayFill
                                                                                size={20}
                                                                                color="green"
                                                                                title="Start"
                                                                                onClick={() => handleToggleTimer(itm.taskId, actions.START)}
                                                                            />
                                                                        )}
                                                                    </>
                                                                )}

                                                                {/* ASSIGNED ICON */}
                                                                {isAssignedIcon && (
                                                                    <span title="Assigned" style={{ color: "green", fontSize: "25px" }}>
                                                                        <Icon.PersonCheckFill />
                                                                    </span>
                                                                )}

                                                                {/* ASSIGN BUTTON */}
                                                                {canShowAssign && (
                                                                    <span title="Assign" style={{ fontSize: "25px" }}>
                                                                        <Icon.PersonAdd onClick={() => handleAssignModelOpen(itm)} />
                                                                    </span>
                                                                )}
                                                                {/* {showAssigned ? (
                                                                    <span
                                                                        data-toggle="tooltip"
                                                                        title="Assigned"
                                                                        style={{ color: "green", fontSize: "25px" }}
                                                                    >
                                                                        <Icon.PersonCheckFill />
                                                                    </span>
                                                                ) : !showAssign ? (
                                                                    <span
                                                                        data-toggle="tooltip"
                                                                        title="Assign"
                                                                        style={{ color: "#000000", fontSize: "25px" }}
                                                                    >
                                                                        <Icon.PersonAdd onClick={() => handleAssignModelOpen(itm)} />
                                                                    </span>
                                                                ) : null} */}
                                                            </span>

                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="18" className="text-center">No data available</td>
                                            </tr>
                                        )}
                                </tbody>
                            )
                                :
                                <tr>
                                    <td colSpan="18" className="text-center">No Task Available</td>
                                </tr>
                            }
                        </table>
                    </div>
                </div>

                {allAllocatedTasks?.data !== null || allAllocatedTasks?.data?.length > 0 && filterAllTasks?.data?.length > 0 || !showNoDataFound ? (
                    <div className='pagination-wrapper p-0'>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={filterAllTasks?.data?.length > 0 ? filterAllTasks?.noOfPages : allAllocatedTasks?.noOfPages}
                            onPageChange={handlePageChange}
                            onDocsPerPage={handleDocsPerPage}
                            docsPerPage={docsPerPage}
                        />
                    </div>
                ) : (
                    ''
                )}
            </Container>
        </div>
    )
}

export default AllocatedTask;